export default "__VITE_ASSET__7571f774__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg12__"